import { api } from '../../../shared/api/client';

export const changeIpAddress = (data = {}) => api.post('/partner/changeIpAddress', data);
export const changePasswordChildPartner = (params = {}) => api.post('child-partner/changePasswordChildPartner', params);
export const getFeesChildPartner = (userId) => api.get('child-partner/getFeesChildPartner', { params: { user_id: userId } });
export const updateFeeChildPartner = (data) => api.post('child-partner/updateFeeChildPartner', data);
export const createChildPartner = (params = {}) => api.post('child-partner/createChildPartner', params);
export const createPartner = (data = {}) => api.post('partner/createPartner', data);
export const getChildPartner = (params = {}) => api.post('child-partner/getChildPartners', params);
export const getInfoTelegram = (userId) => api.get('partner/getInfoTelegram', { params: { userId } });
export const getIpAddress = (userId = {}) => api.get('/partner/getIpAddress', { params: { user_id: userId } });
export const getPartners = (params = {}) => api.post('partner/getPartners', params);
export const searchPartner = (q = {}) => api.get('partner/searchPartner', { params: { q } });
export const updateBalance = (data = {}) => api.post('partner/updateBalance', data);
export const updateChildPartner = (params = {}) => api.post('child-partner/updateChildPartner', params);
export const updateInfo = (data = {}) => api.post('partner/updateInfo', data);
export const updateInfoTelegram = (userId, data = {}) => api.post('partner/updateInfoTelegram', data, { params: { userId } });

export const createTelegram = (telegramData) => api.post('/telegram/create', telegramData);
export const deleteTelegram = (uuid) => api.delete(`/telegram/delete/${uuid}`);
export const getTelegramList = (userId) => api.get(`/telegram/list?user_id=${userId}`);

export const adminChangeIpAddress = (data = {}) => api.post('/admin/administration/changeIpAddress', data);
export const createAdministrator = (data = {}) => api.post('admin/administration/createAdministrator', data);
export const getAdministrators = (params = {}) => api.post('admin/administration/getAdministrators', params);
export const adminGetIpAddress = (adminId = {}) => api.get('/admin/administration/getIpAddress', {
    params: { admin_id: adminId },
});
export const adminUpdateInfo = (data = {}) => api.post('admin/administration/updateInfo', data);

export const createDeductionFee = (params = {}) => api.post('/deduction-fees/createDeductionFee', params);
export const deleteDeductionFee = (params = {}) => api.post('/deduction-fees/deleteDeductionFee', params);
export const getChildPartners = () => api.get('/deduction-fees/getChildPartners');
export const getDeductionFees = (params = {}) => api.post('/deduction-fees/getDeductionFees', params);
export const getMainPartners = () => api.get('/deduction-fees/getMainPartners');
export const getPartnerStatistics = (data = {}) => api.post('/deduction-fees/getPartnerStatistics', {
    userId: data.userId,
    startDate: data.startDate,
    endDate: data.endDate,
});
export const getStatistics = (params = {}) => api.post('/deduction-fees/getStatistics', params);
export const updateDeductionFee = (params = {}) => api.post('/deduction-fees/updateDeductionFee', params);
